/* eslint-disable no-undef */
import { Box } from '@mui/material'
import { useParams } from 'react-router-dom'
import { useState } from 'react'
import { useCountries } from 'hooks/useCountries'
import ServiceAreasProvider, {
  useServiceAreas,
} from 'providers/ServiceAreasProvider'
import LoadingIndicator from 'components/LoadingIndicator/LoadingIndicator'
import { ServiceAreaSidebar } from './ServiceAreaSidebar'
import { ServiceAreaMap } from './ServiceAreaMap'
import { DeliverySlotCalendar } from './DeliverySlotCalendar'
import { PickupSlotCalendar } from './PickupSlotCalendar'
import { NewGroupModal } from './NewGroupModal'
import { NewCollectionPointModal } from './NewCollectionPointModal'

const NEW_DELIVERY_GROUP = 'NewDeliveryGroup'
const NEW_COLLECTION_POINT = 'NewCollectionPoint'

const ServiceAreas = () => {
  const { placeId } = useParams()
  const {
    isLoading: isLoadingGetRequest,
    error,
    isLoadingPlace,
    isLoadingCollectionPoints,
    placeError,
    collectionPointsError,
    selectedDeliveryArea,
    selectedCollectionPoint,
  } = useServiceAreas()

  const { countries } = useCountries()
  // overlays tracks temporary polygons that can be deleted if discarded
  const [overlays, setOverlays] = useState<google.maps.Polygon[] | []>([])
  const [groupModal, setGroupModal] = useState({
    right: false,
  })
  const [deliveryAreaId, setDeliveryAreaId] = useState<number | null>(null)
  const [collectionPointModal, setCollectionPointModal] = useState({
    right: false,
  })
  const [isEditing, setIsEditing] = useState<boolean>(false)
  const [drawnPath, setDrawnPath] = useState<
    { lat: number; lng: number }[][] | []
  >([])

  const handleOpenModal = (_: string, innerValue: string) => {
    if (innerValue === NEW_DELIVERY_GROUP) {
      setGroupModal({ right: true })
    }
    if (innerValue === NEW_COLLECTION_POINT) {
      setCollectionPointModal({ right: true })
    }
  }

  // delete unsaved drawn polygons when selecting other delivery area groups
  const deleteShapes = (polygons: google.maps.Polygon[]) => {
    polygons.forEach((p) => p.setMap(null))
  }

  if (isLoadingGetRequest || isLoadingPlace || isLoadingCollectionPoints)
    return <LoadingIndicator />
  if (error || placeError || collectionPointsError) return <h1>Error</h1>
  return (
    <Box sx={{ display: 'flex' }}>
      <ServiceAreaSidebar
        setIsEditing={setIsEditing}
        placeId={placeId as string}
        handleOpenModal={handleOpenModal}
        setDrawnPath={setDrawnPath}
        overlays={overlays}
        deleteShapes={deleteShapes}
        setDeliveryAreaId={setDeliveryAreaId}
      />
      <Box
        sx={{
          paddingBottom: 0,
          flex: 1,
        }}>
        <ServiceAreaMap
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          setOverlays={setOverlays}
          overlays={overlays}
          drawnPath={drawnPath}
          setDrawnPath={setDrawnPath}
          deleteShapes={deleteShapes}
          deliveryAreaId={deliveryAreaId}
          setDeliveryAreaId={setDeliveryAreaId}
        />
        {Boolean(selectedDeliveryArea.id) && <DeliverySlotCalendar />}
        {Boolean(selectedCollectionPoint.id) && <PickupSlotCalendar />}
      </Box>
      <NewGroupModal
        modal={groupModal}
        setModal={setGroupModal}
        placeId={placeId || ''}
      />
      <NewCollectionPointModal
        modal={collectionPointModal}
        setModal={setCollectionPointModal}
        placeId={placeId || ''}
        countries={countries}
      />
    </Box>
  )
}

export const ServiceAreaWrapper = () => {
  const { placeId } = useParams()
  return (
    <ServiceAreasProvider placeId={placeId as string}>
      <ServiceAreas />
    </ServiceAreasProvider>
  )
}
